import { gql, useMutation } from '@apollo/client';
import { GET_DPO_TASKS } from './useDpoTasksQuery';

const SET_DPO_TASK_ENABLED = gql`
  mutation SetDpoTaskEnabled($companyId: String!, $taskId: String!, $enabled: Boolean!) {
    setDpoTaskEnabled(companyId: $companyId, taskId: $taskId, enabled: $enabled)
  }
`;

export interface SetDpoTaskEnabledResult {
  setDpoTaskEnabled: boolean;
}

export interface SetDpoTaskEnabledInput {
  companyId: string;
  taskId: string;
  enabled: boolean;
}

export function useDpoTaskSetEnabledMutation(companyId: string) {
  return useMutation<SetDpoTaskEnabledResult, SetDpoTaskEnabledInput>(SET_DPO_TASK_ENABLED, {
    refetchQueries: [{ query: GET_DPO_TASKS, variables: { companyId } }],
  });
}
